import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/LoginSso.vue'),
    meta: { public: true, layout: 'blank' },
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('@/pages/PrivacyPolicy.vue'),
    meta: { public: true, layout: 'blank' },
  },
  {
    path: '/',
    component: () => import('@/layouts/AppShell.vue'),
    children: [
      { path: '', redirect: '/dashboard' },
      { path: 'dashboard', name: 'dashboard', component: () => import('@/pages/Dashboard.vue') },
      { path: 'projects', name: 'projects', component: () => import('@/pages/Projects.vue') },
      { path: 'projects/:id', name: 'project-detail', component: () => import('@/pages/ProjectDetail.vue') },
      { path: 'projects/:id/gantt', name: 'project-gantt', component: () => import('@/pages/ProjectGantt.vue') },
      { path: 'projects/:id/batches', name: 'project-batches', component: () => import('@/pages/BatchRecipes.vue') },
      { path: 'plate', name: 'plate', component: () => import('@/pages/Plate.vue') },
      { path: 'capacity', name: 'capacity', component: () => import('@/pages/Capacity.vue') },
      { path: 'materials', name: 'materials', component: () => import('@/pages/Materials.vue') },
      { path: 'daily-logs', name: 'daily-logs', component: () => import('@/pages/DailyLog.vue'), meta: { roles: ['admin', 'scheduler', 'foreman'] } },
      { path: 'scheduling', name: 'scheduling', component: () => import('@/pages/SchedulingL2.vue'), meta: { roles: ['admin', 'scheduler'] } },
      { path: 'reports', name: 'reports', component: () => import('@/pages/Reports.vue') },
      { path: 'admin', name: 'admin', component: () => import('@/pages/Admin.vue'), meta: { roles: ['admin'] } },
      { path: 'admin/audit', name: 'audit-log', component: () => import('@/pages/AuditLog.vue'), meta: { roles: ['admin'] } },
    ],
  },
  { path: '/:pathMatch(.*)*', component: () => import('@/pages/NotFound.vue'), meta: { public: true } },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();
  if (!auth.loaded) await auth.fetchMe();

  if (to.meta?.public) return true;

  if (!auth.isAuthenticated) {
    return { name: 'login', query: { return_to: to.fullPath } };
  }
  const required = (to.meta?.roles as string[] | undefined) ?? [];
  if (required.length > 0 && !auth.hasRole(...required)) {
    return { name: 'dashboard', query: { error: 'forbidden' } };
  }
  return true;
});
